export const environment = {
  production: false,
  apiUrl: 'https://mlgdev.mx/caeloyaltyprogramapi',
  oktaConfig: {
    issuer: 'https://secure.ite.pepsico.com/oauth2/default',
    clientId: '0oa2nj336jjV46Imi0h8',
    allowedOrigins: ['https://mlgdev.mx/caeloyaltyprogramapi'],
  },
  siteKey: '0x4AAAAAACFgXlf4KBWr_8C6',
  tokenName: 'CAE',
  isScanning: false,
};
